import SearchField from "../SearchField/SearchField";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import "./QSSP.css";
import SPQSFormGroup from "./SPQSFormGroup";

const QSSPPackaging = ({ clearfield }) => {
  // Load context values
  const { SPQS, setSPQS, setSPQSData } = useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, undoListSPQS } = useSPQSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      SPQSEdits,
      editIDSPQS,
      setEditIDSPQS,
      setSPQS,
      setSPQSData,
      addEdits,
      undoListSPQS,
      origin,
      destination
    );
  };
  return (
    <fieldset>
      <legend>Packaging:</legend>
      {SPQS.qstype !== 2 ? (
        <>
          <div className='form-group'>
            <label>BagSize:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getbagsizes'
              value={SPQS.bagSize || ""}
              valueName='bagSize'
              valueID='bagSizeID'
              customplaceholder='bagSize'
              onItemSelect={(item) => {
                localHandleInputSelect(item, "bagSize", "bagSize");
              }}
              clearfield={clearfield}
            />
          </div>
          <div className='form-group'>
            <label>Marks:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getbagmarktypes'
              value={SPQS.bagMarkType || ""}
              valueName='bagMarkType'
              valueID='bagMarkTypeID'
              customplaceholder='bagMarks...'
              onItemSelect={(item) => {
                localHandleInputSelect(item, "bagMarkType", "bagMarkType");
              }}
              clearfield={clearfield}
            />
          </div>
        </>
      ) : (
        <>
          <SPQSFormGroup
            readOnly={SPQS.qstype === 2}
            labelname={"Bag Size:"}
            inputname={"bagSize"}
            inputtype={"text"}
          />
          <SPQSFormGroup
            readOnly={SPQS.qstype === 2}
            labelname={"Marks:"}
            inputname={"bagMarkType"}
            inputtype={"text"}
          />
        </>
      )}
    </fieldset>
  );
};

export default QSSPPackaging;
